import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-326abb36"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Voir les fiches")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, _normalizeProps(_guardReactiveProps(_ctx.formParams)), {
    footer: _withCtx(() => [
      _createVNode(_component_RouterLink, {
        class: "btn btn-secondary",
        to: { name: 'sheets.index', query: { user_id: _ctx.user?.id } }
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["to"]),
      (_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.connectAs && _ctx.connectAs(...args))),
              type: "button"
            }, " Se connecter en tant que "),
            _createElementVNode("button", {
              class: "btn btn-secondary reset-password",
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sendWelcomeEmail && _ctx.sendWelcomeEmail(...args)))
            }, " Envoyer Email accès au compte ")
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}